import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import { AtlassianEmailUserIdMapping } from '@atlassian/cssxp-types-atlasaccnt';
import { AuthenticatedUserProfile } from '@atlassian/cssxp-typescommon';
import { CustomerProfile } from '@atlassian/cssxp-ecc-types';
import axios, { CancelToken } from 'axios';

// Hardcoded to run and connect auth with different port - localhost
// const client = createAxiosClient({ baseURL: 'http://localhost:3001/api/v2' }, ServiceProxyMap.AUTH);
const client = createAxiosClient({ baseURL: '/api/1' }, ServiceProxyMap.AUTH);
const appSpecificClient = createAxiosClient({ baseURL: '' }, '');

export const getUserProfile = async (): Promise<AuthenticatedUserProfile> => {
  const userProfileResponse = await client.get('/user/profile');
  return userProfileResponse.data;
};

export const getUserRedirectionData = async (): Promise<AuthenticatedUserProfile> => {
  const redirectionResponse = await client.get('/user/redirectionData');
  return redirectionResponse.data;
};

export const getUIConfigData = async () => {
  const client = createAxiosClient({ baseURL: '/api/1' }, '');
  const dataResponse = await client.get('/ui-config');
  return dataResponse.data;
};

export const fetchAtlassianAccountID = async (requestPayload: {
  emails: Array<string>;
}): Promise<Array<AtlassianEmailUserIdMapping>> => {
  const AtlassianAccountIDResponse = await client.post('/users/fetch/by-email', requestPayload);
  return AtlassianAccountIDResponse.data;
};

export const createAtlassianAccount = async (email: string, application: string): Promise<{ id: string }> => {
  const AtlassianAccountResponse = await client.post('/users/signup', { email, application });
  return AtlassianAccountResponse.data;
};

// Ideally this function will only be used by partner app
// For now removing type as its stopping us from publishing proxies as lib
// TODO: add PartnerAccount back after repo migrated
export const getPartnerProfile = async (): Promise<any> => {
  const PartnerProfileResponse = await client.get('/user/partner-profile');
  return PartnerProfileResponse.data;
};

export const getPartnerOrAdvocateProfileInformation = async (transactionAccountId?: string): Promise<any> => {
  const PartnerProfileResponse = await client.get('/user/partner-profile', {
    ...(transactionAccountId && { params: { transactionAccountId } }),
  });
  return PartnerProfileResponse.data;
};

export const getCustomerProfile = async (): Promise<CustomerProfile> => {
  const customerProfileResponse = await client.get('/user/customer-profile');
  return customerProfileResponse.data;
};

export const getFeatureFlag = async (flagKey: string, cancelToken?: CancelToken): Promise<boolean> => {
  const response = await appSpecificClient.get<boolean>(
    `/feature-flag/${flagKey}`,
    cancelToken && {
      cancelToken,
    }
  );

  return response.data;
};
